import { Class } from './utils'

//noinspection JSCommentMatchesSignature,JSCommentMatchesSignature
export default Class (
  /**  @lends View# */
  {		
    myController: null,
	
    searchers: null,
	
    hasStarted: false,
		
    /** 
	 * 
	 * @class Base class for user interface of Septima Search. Implementations must be derived from this class. For an example, please see {@link DefaultView}
	 * @constructs View
	 * @param {Object} options
	 * @param [options.limit=15] {Integer} The number of search results to show
	 */
    initialize: function(options){
      if (options === undefined || options.input === undefined){
        throw "View(options): Options.input is missing."; 
      }
      this.options = options;
      this.limit = 15;
      if (options.limit !== undefined){
        this.limit = options.limit;
      }
      if (options.controller === undefined){
        throw "View(handlers): controller is missing."; 
      }else{
        this.myController = options.controller;
      }
      this.searchers = this.myController.getSearchers();
      this.draw();
      this.hasStarted = true;
    },

    /**
	 * This method MUST be implemented
	 */
    draw: function(){
      throw("Must be implemented");
    },

    /**
	 * This method MUST be implemented
	 */
    setSuggestions: function(/*searcherTitle, suggestions*/){
      throw("Must be implemented");
    },

    /**
	 * This method MUST be implemented
	 */
    setResults: function(/*results*/){
      throw("Must be implemented");
    },

    /**
	 * This method MUST be implemented
	 * Write a string in the search box and perform a search
	 * @param {string} searchText
	 */
    doTextSearch: function(/*results*/){
      throw("Must be implemented");
    },
	
    /**
	 * This method MAY be implemented
	 */
    error: function(/*searcher, errorText*/){
		
    },
		
    /**
	 * This method MUST be implemented
	 * Remove focus from the view (thus hiding the list of search results)
	 * @param {boolean} force. Blur even if others still have an interest in showing the list
	 */
    blur: function(/*force*/){},
	
    CLASS_NAME: 'ViewBase'

  });
